import _ from 'lodash';
import { lsApiService, lsErrorService } from 'ls-vue-common';
import {
  BILLING_HISTORY__RESET,
  BILLING_HISTORY__MUTATE_ITEMS,
  BILLING_HISTORY__MUTATE_LOADING_STATUS,
  BILLING_HISTORY__GET_ITEMS,
  BILLING_HISTORY__UPDATE_ITEMS,
} from '@/store/types';
import { lsModuleHelpers } from '../helpers';

const createInitialState = () => {
  return {
    loadingStatus: {
      isLoading: false,
      isUpdating: false,
    },
    items: [],
    pagination: {
      currentPage: 0,
      itemsPerPage: 10,
      totalItems: 0,
      links: {
        next: null,
        previous: null,
      },
    },
  };
};

export const mutations = {
  [BILLING_HISTORY__RESET](state) {
    lsModuleHelpers.resetState({ state, createInitialState });
  },
  [BILLING_HISTORY__MUTATE_ITEMS](state, payload) {
    state.items = [...payload.items];
    state.pagination = payload.pagination;
  },
  [BILLING_HISTORY__MUTATE_LOADING_STATUS](state, payload) {
    _.assign(state.loadingStatus, payload);
  },
};

export const actions = {
  [BILLING_HISTORY__GET_ITEMS]({ commit, rootState } = {}) {
    commit(BILLING_HISTORY__MUTATE_LOADING_STATUS, {
      isLoading: true,
      isUpdating: true,
    });
    const { customer_id } = rootState.auth.user;
    return lsApiService
      .request({
        method: 'GET',
        apiVersion: 'v2',
        route: `/customers/${customer_id}/billing`,
        params: {
          page: 1,
        },
      })
      .then((response) => {
        commit(BILLING_HISTORY__MUTATE_ITEMS, {
          items: response.data,
          pagination: response.pagination,
        });
      })
      .catch((error) => {
        lsErrorService.log({ error, showAlert: true });
      })
      .finally(() => {
        commit(BILLING_HISTORY__MUTATE_LOADING_STATUS, {
          isLoading: false,
          isUpdating: false,
        });
      });
  },

  [BILLING_HISTORY__UPDATE_ITEMS]({ commit, rootState }, { page } = {}) {
    commit(BILLING_HISTORY__MUTATE_LOADING_STATUS, {
      isUpdating: true,
    });
    const { customer_id } = rootState.auth.user;
    return lsApiService
      .request({
        method: 'GET',
        apiVersion: 'v2',
        route: `/customers/${customer_id}/billing`,
        params: {
          page,
        },
      })
      .then((response) => {
        commit(BILLING_HISTORY__MUTATE_ITEMS, {
          items: response.data,
          pagination: response.pagination,
        });
      })
      .catch((error) => {
        lsErrorService.log({ error, showAlert: true });
      })
      .finally(() => {
        commit(BILLING_HISTORY__MUTATE_LOADING_STATUS, {
          isUpdating: false,
        });
      });
  },
};

export const getters = {};

export const billingHistory = {
  state: createInitialState,
  mutations,
  actions,
  getters,
};
